import { render, staticRenderFns } from "./ChatSettings.vue?vue&type=template&id=589f4d5c&scoped=true&"
import script from "./ChatSettings.vue?vue&type=script&lang=js&"
export * from "./ChatSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettings.vue?vue&type=style&index=0&id=589f4d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589f4d5c",
  null
  
)

export default component.exports